import DefaultLinkToStore from './DefaultLinkToStore';
import generateRender from 'shared/utils/generateRender';

const LinkToStore = generateRender({
  default: DefaultLinkToStore,
});

export default LinkToStore;

